export { default as GDMMaps } from './GDMMaps';

export type { GDMMapsComponent, GDMMapsProps } from './GDMMaps.type';
